var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-lg text-white w-full px-2 focus:outline-none focus:shadow-outline",class:_vm.colorButton},[_c('span',{staticClass:"flex-shrink-0"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }